import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';

const Home = () => {
  const [providerCount, setProviderCount] = useState(0);

  const fetchProviderCount = async () => {
    try {
      const response = await axios.get('/api/active-provider-count');
      setProviderCount(response.data.number_of_active_providers);
    } catch (error) {
      console.error('Error fetching provider count:', error);
    }
  };

  useEffect(() => {
    fetchProviderCount();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Home - {process.env.REACT_APP_SITE_NAME}</title>
      </Helmet>
      <div>
        <h2>Active Providers: {providerCount}</h2>
      </div>
    </div>
  );
};

export default Home;
